import { render, staticRenderFns } from "./BulkRateAssign.vue?vue&type=template&id=1f1be741&scoped=true"
import script from "./BulkRateAssign.vue?vue&type=script&lang=js"
export * from "./BulkRateAssign.vue?vue&type=script&lang=js"
import style0 from "./BulkRateAssign.vue?vue&type=style&index=0&id=1f1be741&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f1be741",
  null
  
)

export default component.exports